// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
// Note: require.context is a webpack specific function and doesn't have a direct import equivalent
// It needs to remain as is
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
